import React, { useState, useEffect } from 'react';
import style from './notifyconfig.module.css';
import { Table, Input, Pagination, Space, Dropdown, Checkbox, message } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { CiMenuKebab, CiSearch } from 'react-icons/ci';
import Button from '../../components/Basic/button';
import FormModal from '../../components/Modal/FormModal';
import Features from '../../Forms/NotificationConfigForm'
import Header from '../../components/Header/header';
import { connect } from 'react-redux';
import * as Actions from "../../store/slices/notificationConfig/notificationConfig"
import { hasPermission } from '../../utils/premission';
import { PERMISSIONS } from '../../utils/constant/permissions';
import { useNavigate } from 'react-router-dom';

interface Api {
    NotificationConfig_Red: any;
    getAllRole: (page: number, size: number) => unknown;
    getConfigById: (id: number) => unknown;
    createConfig: (data: any) => unknown;
    updateConfig: (id: number, data: any) => unknown;
    deleteConfig: (id: number) => unknown;
}




const MultiViewTable: React.FC<Api> = ({ NotificationConfig_Red, getAllRole, getConfigById, createConfig, updateConfig, deleteConfig }) => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [searchText, setSearchText] = useState<string>('');
    const [selectedColumns, setSelectedColumns] = useState<string[]>(['UserId', 'Email', 'Type', 'CreatedByUser']);
    const [loadingText, setLoadingText] = useState<boolean>(true)
    const [open, setOpen] = useState(false);
    const [showForm, setShowForm] = useState<boolean>(false);
    const [modalText, setModalText] = useState<string>('')
    const [selectedRole, setSelectedRole] = useState<any>(null);
    const [isFetchingEdit, setIsFetchingEdit] = useState(false);

    console.log(selectedRole, 'select')

    const apiResponse = NotificationConfig_Red?.data?.[0]?.res;
    const roles = apiResponse?.data || [];
    const total = apiResponse?.totalDocuments || 0;
    const loading = false;

    // Security Policy: Check for status codes 1004 and 1005
    useEffect(() => {
        if (NotificationConfig_Red?.dataSingle?.[0]?.res?.status === '1004') {
            message.error(NotificationConfig_Red.dataSingle[0].res.message);
            localStorage.clear();
            navigate('/');
        } else if (NotificationConfig_Red?.dataSingle?.[0]?.res?.status === '1005') {
            message.warning(NotificationConfig_Red.dataSingle[0].res.message);
        }
    }, [NotificationConfig_Red, navigate]);

    const openForm = (role: any = null) => {
        setSelectedRole(role);
        setShowForm(true);
    };



    useEffect(() => {
        getAllRole(
            currentPage,
            pageSize
        );
    }, [getAllRole, currentPage, pageSize]);


    const filteredData = roles.filter((item: any) =>
        item.userId?.toString().toLowerCase().includes(searchText) ||
        item.email?.toLowerCase().includes(searchText) ||
        item.type?.toLowerCase().includes(searchText) ||
        item.createdByUser?.toLowerCase().includes(searchText)
    );

    console.log(NotificationConfig_Red, 'sd')




    const handleCheckboxChange = (checked: boolean, column: string) => {
        setSelectedColumns((prevSelected) =>
            checked ? [...prevSelected, column] : prevSelected.filter((col) => col !== column)
        );
    };




    const Addhandle = () => {
        setShowForm(true);
    };

    const Backhandle = () => {
        setShowForm(false); // Show the table and hide the form
    };

    const [selectedConfig, setSelectedConfig] = useState<any>(null);

    const HandleDelete = (record: any) => {
        setSelectedConfig(record);
        setModalText('Are you sure you want to delete this configuration?');
        setOpen(true);
    }

    const confirmDelete = async () => {
        if (!selectedConfig) return;
        
        const result : any= await deleteConfig(selectedConfig.userConfigurationId);
        if (result?.success) {
            message.success('Configuration deleted successfully');
            getAllRole(currentPage, pageSize);
        } else {
            message.error('Failed to delete configuration');
        }
        setOpen(false);
        setSelectedConfig(null);
    };
    // const HandleApprove = () => {
    //     setModalText('Approve Campaign');
    //     setOpen(true);
    // }


    const actionMenu = (
        <Space direction="vertical" className={style.actions}>  

            {hasPermission(PERMISSIONS.USER_CONFIG_UPDATE) && (
            <div className={style.dropdownItem} onClick={Addhandle}>Edit</div>
            )}
        </Space>
    );




    const allColumns = [
        {
            title: 'User ID',
            dataIndex: 'userId',
            key: 'UserId',
            width: 180,
            sorter: (a: any, b: any) => a.userId - b.userId,
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'Email',
            width: 250,
            render: (email: string) => email || 'N/A',
            sorter: (a: any, b: any) => (a.email || '').localeCompare(b.email || ''),
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'Type',
            width: 150,
            sorter: (a: any, b: any) => a.type.localeCompare(b.type),
        },
        {
            title: 'Created By User',
            dataIndex: 'createdByUser',
            key: 'CreatedByUser',
            width: 150,
            render: (val: string) => val || '-',
        },
        {
            title: 'Action',
            key: 'action',
            fixed: 'right' as const,
            width: 60,
            render: (_: any, record: any) => {          
                const actionMenu = (
                    <Space direction="vertical" className={style.actions}>
                        {hasPermission(PERMISSIONS.USER_CONFIG_UPDATE) && (
                        <div className={style.dropdownItem} onClick={() => openForm(record)}>
                            Edit
                        </div>
                        )}
                        {hasPermission(PERMISSIONS.USER_CONFIG_DELETE) && (
                        <div className={style.dropdownItem} onClick={() => HandleDelete(record)}>
                            Delete
                        </div>
                        )}
                    </Space>
                );

                return (
                    <Dropdown overlay={actionMenu} trigger={['click']} placement="bottomRight">
                        <CiMenuKebab className={style.actionIcon} />
                    </Dropdown>
                );
            },
        },
    ];
    const filteredColumns = allColumns.filter((col) => selectedColumns.includes(col.key) || col.key === 'action');

    // const filteredData = dataSource.filter((item) =>
    //     item.RoleName.toLowerCase().includes(searchText) ||
    //     item.Description.toLowerCase().includes(searchText) ||
    //     item.Active.toLowerCase().includes(searchText)
    // );

    const items = [

        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('UserId')}
                    value={'UserId'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'UserId')}
                >
                    User ID
                </Checkbox>
            ),
            key: '2',
        },

        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('Email')}
                    value={'Email'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'Email')}
                >
                    Email
                </Checkbox>
            ),
            key: '4',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('Type')}
                    value={'Type'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'Type')}
                >
                    Type
                </Checkbox>
            ),
            key: '5',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('CreatedByUser')}
                    value={'CreatedByUser'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'CreatedByUser')}
                >
                    Created By User
                </Checkbox>
            ),
            key: '6',
        },


    ];


    useEffect(() => {
        setLoadingText(true)
        setTimeout(() => {
            setLoadingText(false)
        }, 2000)
    }, [])


    return (
        <>
            <Header />
            <FormModal modalTitle={modalText} Subtitle={''} open={open} setOpen={setOpen} onOk={confirmDelete} onCancel={() => setOpen(false)} />
            {showForm ? (
                <Features configId={selectedRole?.userConfigurationId} Back={Backhandle} initialValues={selectedRole} isEdit={!!selectedRole} />
            ) : (
                // Render the table when not showing the form
                <>
                    <div className={style.Route}>
                        <h5>Notification Configuration</h5>
                        <div className={style.btns}>
                            {hasPermission(PERMISSIONS.USER_CONFIG_CREATE) && (
                            <Button
                                Text={'Create Configuration'}
                                buttonClass={style.createBtn}
                                onClick={Addhandle}
                                Disable={loadingText}
                            />
                            )}
                        </div>
                    </div>
                    <div className={style.container}>
                        <Space className={style.SearchTable}>
                            <div className={style.SearchBar}>
                                <Input
                                    placeholder="Search..."
                                    prefix={<CiSearch size={20} />}
                                    // suffix={<CiFilter size={20} className={style.filterIcon} />}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    style={{ width: 200 }}
                                    className={style.inputSearch}
                                />
                                <Dropdown
                                    menu={{ items }}
                                    trigger={['click']}
                                >
                                    <SettingOutlined className={style.tableSettings} />
                                </Dropdown>
                            </div>
                        </Space>
                        <Table
                            loading={loadingText}
                            columns={filteredColumns}
                            dataSource={filteredData}
                            pagination={false}
                            // rowSelection={{
                            //     type: 'checkbox',
                            // }}
                            size="small"
                            onChange={(pagination, filters, sorter) => {
                                if (!Array.isArray(sorter)) {
                                    console.log('Field:', sorter.field);
                                    console.log('Order:', sorter.order);
                                }
                            }}
                        />
                        <Pagination
                            align="end"
                            showTotal={(tot) => `Total ${tot} items`}
                            current={currentPage + 1}
                            total={total}
                            pageSize={pageSize}
                            pageSizeOptions={['10', '20', '50']}
                            showSizeChanger
                            onChange={(page, size) => {
                                if (size !== pageSize) {
                                    setCurrentPage(0);
                                    setPageSize(size);
                                } else {
                                    setCurrentPage(page - 1);
                                }
                            }}
                            style={{ marginTop: 16 }}
                        />
                    </div>
                </>
            )}
        </>
    );
};

function mapStateToProps(state: any) {
    return {
        NotificationConfig_Red: state.NotificationConfig_Red
    }
}

export default connect(mapStateToProps, Actions)(MultiViewTable)